import { useEffect, useState, type CSSProperties } from "react"
import { Link } from "react-router-dom"
import { api } from "../../lib/api"
import type { Materiais as Resposta } from "../../types"
import { listar } from "../../lib/texto"

/**
 * Os guias em PDF da preparação completa. Só quem tem um produto com o bônus
 * os abre — o link vai a uma rota Rails que confere o acesso e entrega o
 * arquivo, que mora fora de public/. Para quem não tem, uma linha só, e só
 * depois do primeiro simulado: no primeiro acesso o painel é a carta do
 * diagnóstico, e outra oferta ali competiria com ela.
 */
export default function Materiais({ mostrarConvite }: { mostrarConvite: boolean }) {
  const [dados, setDados] = useState<Resposta | null>(null)

  useEffect(() => {
    // Enfeite do painel: se falhar, o painel segue sem a seção.
    api.get<Resposta>("/materiais").then(setDados).catch(() => {})
  }, [])

  if (!dados || dados.materiais.length === 0) return null

  if (!dados.liberados) {
    if (!mostrarConvite) return null
    return (
      <p className="revela text-center text-sm text-slate-500" style={{ "--atraso": "260ms" } as CSSProperties}>
        Na preparação completa do Arrais: {dados.materiais.length} guias em PDF —{" "}
        {listar(dados.materiais.map((m) => m.titulo))}.{" "}
        <Link to="/acesso?habilitacao=arrais-amador" className="font-semibold text-navy-800 underline underline-offset-4">
          Ver a preparação completa
        </Link>
      </p>
    )
  }

  return (
    <section aria-label="Materiais" className="space-y-4">
      <h2
        className="revela font-mono text-[0.65rem] uppercase tracking-[0.22em] text-gold-600"
        style={{ "--atraso": "220ms" } as CSSProperties}
      >
        Seus guias em PDF
      </h2>
      <ul className="grid gap-4 sm:grid-cols-3">
        {dados.materiais.map((material, i) => (
          <li
            key={material.slug}
            className="revela flex flex-col rounded-2xl border border-navy-100 bg-white p-5 shadow-sm"
            style={{ "--atraso": `${260 + i * 60}ms` } as CSSProperties}
          >
            <p className="font-mono text-[0.62rem] uppercase tracking-wider text-navy-400">
              PDF · {material.paginas} páginas
            </p>
            <h3 className="mt-2 font-display text-xl leading-tight text-navy-900">{material.titulo}</h3>
            <p className="mt-2 flex-1 text-sm leading-relaxed text-slate-600">{material.descricao}</p>
            {/* Abre em outra aba: no celular o visualizador de PDF toma a tela
                inteira, e voltar ao painel seria voltar do zero. */}
            <a
              href={material.url}
              target="_blank"
              rel="noopener"
              className="mt-4 inline-block text-sm font-semibold text-navy-800 underline underline-offset-4"
            >
              Abrir o PDF
            </a>
          </li>
        ))}
      </ul>
    </section>
  )
}
